export enum DigitalStylingStatus {
    Unknown = 0,
    Created = 1,
    Ready = 2,
    Working = 3,
    InternallyApproved = 4,
    Delivered = 5,
    CustomerApproved = 6,
    Redelivery = 7
}

export type ImageUploadResponse = {
    warmStorageReference: string;
    filename: string;
    orderRowId: number;
    category: number;
    uploadTime: Date;
    uploadedByUserId: number;
    contentType: string;
};

export type ImageModel = {
    id: number;
    name: string;
    numberOfImages: number;
    thumbnails: ThumbnailModel[];
    failedUploads: FileMetadata[];
    uploadsInProgress: FileMetadata[];
    filenames: OrderRowFilenames[];
    orderRowProductProperties: any[];
    editedImagesUploadInProgress?: boolean;
};

export type FileMetadata = {
    photoUploadMetadataId: number;
    orderRowId: number;
    filename: string;
};

export type ThumbnailModel = {
    id: number;
    filename: string;
    highResolutionImageReference: string;
    reference: string;
    previewReference: string;
    orderRowName: string;
    orderRowId: number;
    hasUploadedNormal: boolean;
    hasAutoScale: boolean;
    highResolutionWidth: number;
    highResolutionHeight: number;
    isUploadedByCustomer: boolean;
};

type OrderRowFilenames = {
    name: string;
    orderRowId: number;
};

export type CustomerImage = {
    id: number;
    mainImage: string;
    thumbnailImage: string;
    filename: string;
    contentType: string;
};
